/* eslint perfectionist/sort-enums: ["error", { "ignoreCase": false, specialCharacters: 'remove', partitionByNewLine: true }] */
export enum TextDescriptionVariant {
  JUMBO_PRIMARY_BOLD = 'Primary Bold jumbo text',
  JUMBO_PRIMARY_REGULAR = 'Primary Regular jumbo text',
  JUMBO_PRIMARY_XBOLD = 'Primary extra Bold jumbo text',
  JUMBO_SECONDARY_BOLD = 'Secondary Bold Jumbo text',
  JUMBO_SECONDARY_SEMIBOLD = 'Secondary Semi Bold Jumbo text',

  LARGE_PRIMARY_BOLD = 'Primary Bold large text',
  LARGE_PRIMARY_REGULAR = 'Primary Regular large text',
  LARGE_PRIMARY_XBOLD = 'Primary extra Bold large text',
  LARGE_SECONDARY_BOLD = 'Secondary Bold Large text',
  LARGE_SECONDARY_SEMIBOLD = 'Secondary Semi Bold Large text',

  MEDIUM_ITALIC_PRIMARY_BOLD = 'Medium Italic Primary Bold text',
  MEDIUM_ITALIC_SECONDARY_BOLD = 'Medium Italic Secondary Bold text',
  MEDIUM_PRIMARY_BOLD = 'Primary Bold medium text',
  MEDIUM_PRIMARY_LIGHT = 'Primary Light medium text',
  MEDIUM_PRIMARY_MEDIUM = 'Primary Medium medium text',
  MEDIUM_PRIMARY_REGULAR = 'Primary Regular medium text',
  MEDIUM_PRIMARY_SEMIBOLD = 'Primary Semi Bold medium text',
  MEDIUM_PRIMARY_XBOLD = 'Primary extra Bold medium text',
  MEDIUM_SECONDARY_BOLD = 'Secondary Bold Medium text',
  MEDIUM_SECONDARY_SEMIBOLD = 'Secondary Semi Bold Medium text',
  MEDIUM_TERTIARY_REGULAR = 'Medium Tertiary Regular Text',

  REGULAR_ITALIC_PRIMARY_BOLD = 'Regular Italic Primary Bold text',
  REGULAR_ITALIC_SECONDARY_BOLD = 'Secondary Italic Bold Regular text',
  REGULAR_PRIMARY_BOLD = 'Primary Bold regular text',
  REGULAR_PRIMARY_LIGHT = 'Primary Light regular text',
  REGULAR_PRIMARY_MEDIUM = 'Primary Medium regular text',
  REGULAR_PRIMARY_REGULAR = 'Primary Regular regular text',
  REGULAR_PRIMARY_XBOLD = 'Primary extra Bold regular text',
  REGULAR_SECONDARY_MEDIUM = 'Secondary Medium Regular text',
  REGULAR_SECONDARY_SEMIBOLD = 'Secondary Semi Bold Regular text',

  SECONDARY_REGULAR = 'Secondary regular text',
  SMALL_ITALIC_PRIMARY_MEDIUM = 'Primary Italic Medium Small Text',
  SMALL_ITALIC_PRIMARY_REGULAR = 'Primary Italic Regular Small text',
  SMALL_ITALIC_SECONDARY_MEDIUM = 'Secondary Italic Medium Small text',
  SMALL_ITALIC_SECONDARY_SEMIBOLD = 'Secondary Italic Semi Bold Small text',
  SMALL_PRIMARY_BOLD = 'Primary Bold small text',
  SMALL_PRIMARY_MEDIUM = 'Primary Medium small text',
  SMALL_PRIMARY_REGULAR = 'Primary Regular small text',
  SMALL_PRIMARY_XBOLD = 'Primary extra Bold small text',
  SMALL_SECONDARY_MEDIUM = 'Secondary Medium Small text',
  SMALL_SECONDARY_REGULAR = 'Secondary Regular Small text',
  SMALL_SECONDARY_SEMIBOLD = 'Secondary Semi Bold Small text',

  XJUMBO_SECONDARY_BOLD = 'Secondary Bold extra Jumbo text',
  XLARGE_ITALIC_SECONDARY_BOLD = 'Secondary Italic Bold extra Large text',
  XLARGE_PRIMARY_BOLD = 'Primary Bold extra large text',
  XLARGE_PRIMARY_REGULAR = 'Primary Regular extra large text',
  XLARGE_SECONDARY_BOLD = 'Secondary Bold extra Large text',
  XMEDIUM_ITALIC_PRIMARY_BOLD = 'Primary Italic Bold extra medium text',
  XMEDIUM_ITALIC_PRIMARY_REGULAR = 'Primary Italic Regular extra medium text',
  XMEDIUM_PRIMARY_BOLD = 'Primary Bold extra medium text',
  XMEDIUM_PRIMARY_REGULAR = 'Primary Regular extra medium text',
  XMEDIUM_PRIMARY_SEMIBOLD = 'Primary Semi Bold extra medium text',
  XMEDIUM_SECONDARY_SEMIBOLD = 'Secondary extra meduim semi bold text',
  XSMALL_ITALIC_PRIMARY_BOLD = 'Primary Italic extra Bold extra Small text',
  XSMALL_ITALIC_PRIMARY_SEMIBOLD = 'Primary Italic semi Bold extra Small text',
  XSMALL_ITALIC_SECONDARY_SEMIBOLD = 'Secondary Italic Semi Bold extra Small text',
  XSMALL_ITALIC_SECONDARY_XBOLD = 'Secondary Italic extra Bold extra Small text',
  XSMALL_PRIMARY_BOLD = 'Primary Bold extra small text',
  XSMALL_PRIMARY_MEDIUM = 'Primary Medium extra small text',
  XSMALL_PRIMARY_REGULAR = 'Primary Regular extra small text',
  XSMALL_PRIMARY_SEMIBOLD = 'Primary Semi Bold extra small text',
  XSMALL_PRIMARY_XBOLD = 'Primary extra Bold extra small text',
  XSMALL_SECONDARY_BOLD = 'Secondary Bold extra Small text',
  XSMALL_SECONDARY_MEDIUM = 'Secondary Medium extra Small text',
  XSMALL_SECONDARY_REGULAR = 'Secondary Regular extra Small text',
  XSMALL_SECONDARY_SEMIBOLD = 'Secondary Semi Bold extra Small text',

  XXJUMBO_PRIMARY_BOLD = 'Primary Bold very extra Jumbo Text',
  XXJUMBO_PRIMARY_REGULAR = 'Primary Regular very extra Jumbo  Text',
  XXJUMBO_SECONDARY_BOLD = 'Secondary Bold very extra Jumbo Text',
  XXLARGE_PRIMARY_BOLD = 'Primary Bold very extra large text',
  XXLARGE_PRIMARY_XBOLD = 'Primary extra Bold very extra large text',
  XXLARGE_SECONDARY_BOLD = 'Secondary Bold very extra Large text',
  XXSMALL_ITALIC_PRIMARY_BOLD = 'Primary Italic Bold very extra small text',
  XXSMALL_PRIMARY_BOLD = 'Primary Bold very extra small text',
}
